import React,  {useState} from "react";
import { Link   } from "react-router-dom";
import {
  useNewsQuery
} from '../../data/news-data';
import { formatPostTime, APP_URL } from "../../components/config/Common";
import { useSiteSettings } from '../../contexts/site-settings/site-settings';

import { MdOutlineWatchLater } from "react-icons/md";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const CompanyNews = ({tag}) => {
    //console.log('symbol===', tag)
    const { sitelogo } = useSiteSettings();
    const {
        news,
        see_more_link,
        isLoading: loading,
        error,
    } = useNewsQuery({ tag });

    //console.log('news====', news)
    const formatNewsTime = (date) => {
      const now = dayjs();
      const postDate = dayjs(date);
      const diffInDays = now.diff(postDate, "day");
    
      // Show relative time for first 1 days
      if (diffInDays < 1) {
        const diffInMinutes = now.diff(postDate, "minute");
    
        if (diffInMinutes < 1) return "just now";
        if (diffInMinutes < 60) return `${diffInMinutes} min ago`;
    
        const diffInHours = now.diff(postDate, "hour");
        return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
      }
    
      // After 1 days show full date
      return postDate.format("D MMM YYYY");
    };

    return(
        <>
            {!news ? null
            :
            <section className="bg-white shadow-md z-50 rounded-xl p-5">
                <h2 className="text-2xl font-semibold mb-5">News</h2>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {
                    !loading && news?.map(val=>(
                        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden transition duration-300 group">
                            {/* <div className="w-full object-cover overflow-hidden"><Link to={val.link} target="_blank">
                            {val.medium_image ?
                            <img src={`${val.medium_image}`} alt={val.alt_text} className="h-48 w-full object-cover group-hover:scale-110 transition duration-300 ease-in-out" />
                            :
                            <img src={`${process.env.REACT_APP_IMG_URL+sitelogo}`} alt={val.alt_text || val.title} className="h-48 w-full object-contain group-hover:scale-110 transition duration-300 ease-in-out" />
                            }
                            </Link></div> */}
                            <div className="p-4 flex flex-col h-full">
                            <Link to={val.link} title={val.title} target="_blank"><h2  className="text-lg leading-snug text-gray-800 group-hover:text-accent transition line-clamp-2" dangerouslySetInnerHTML={{ __html: val.title }} /></Link>
                            {/* <div className="text-sm py-3" dangerouslySetInnerHTML={{ __html: val.excerpt }}></div> */}
                                <div className="pt-4 flex items-center justify-between text-xs text-gray-500">
                                <div className="flex items-center gap-1">
                                <MdOutlineWatchLater size={14} /> {formatNewsTime(val.date)}
                                </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
                </div>
                <div className="flex items-center justify-end my-3 text-sm text-accent hover:underline"><Link to={`${APP_URL}${see_more_link}`} target="_blank" className='text-white bg-accent hover:bg-secondary shadow-xs font-medium text-sm px-4 py-2.5 focus:outline-none'>Read More News</Link></div>
            </section>
            }
            </>
    )

}
export default CompanyNews